import shuffleUtil from './shuffle'
import duplicateUtil from './duplicate'

export default {
  shuffle: shuffleUtil,
  duplicate: duplicateUtil
}

export const shuffle = shuffleUtil
export const duplicate = duplicateUtil
